<template>
  <b-button-group>
    <o-css-classes
      :items="items"
      :name="name"
      :color-field="colorField"
    ></o-css-classes>

    <b-button
      v-for="btn in buttons"
      :variant="calc_variant(btn)"
      :key="btn.id"
      :pressed="btn.id === value"
      @click="click(btn.id)"
      >{{ btn[textField] }}
    </b-button>

    <b-button
      v-if="other_buttons.length <= 0 && !disableMore && allowUnselect"
      variant="outline-secondary"
      @click="unselect()"
      :style="{ color: 'black' }"
      >Unselect
    </b-button>

    <b-dropdown
      v-if="other_buttons.length > 0 && !disableMore"
      right
      text=""
      variant="outline-dark"
    >
      <b-dropdown-form
        v-if="all_other_buttons.length > maxMoreItems"
        class="p-0"
      >
        <b-form-input v-model="search" autofocus type="search"></b-form-input>
      </b-dropdown-form>
      <b-dropdown-item-button
        v-for="o in other_buttons"
        :key="o.id"
        :active="o.id == value"
        @click="click(o.id)"
        ><span v-if="o.id == value">&#10003;</span>{{ o[textField] }}
      </b-dropdown-item-button>
      <b-dropdown-divider v-if="allowUnselect"></b-dropdown-divider>
      <b-dropdown-item-button @click="unselect()" v-if="allowUnselect"
        >Unselect
      </b-dropdown-item-button>
    </b-dropdown>
  </b-button-group>
</template>

<script>
import _ from "lodash";
import { filter_active_list } from "@/vue-ocom/utils/active.js";
import OCssClasses from "./OCssClasses.vue";

export default {
  name: "OSpeedSelect",
  components: { OCssClasses },
  model: {
    prop: "value",
    event: "input",
  },
  data() {
    return {
      search: "",
    };
  },
  props: {
    validator: { type: Object, default: null },
    formState: { type: Object, default: null },
    items: { type: Array, default: null },
    value: { type: Number },
    textField: { type: String, default: "description" },
    colorField: { type: String, default: "" },
    quickDisplayOrderField: {
      type: String,
      default: "quick_display_order",
    },
    disableMore: { type: Boolean, default: false },
    maxMoreItems: { type: Number, default: 10 },
    allowUnselect: { type: Boolean, default: false },
    name: { type: String, default: "speedselect" },
  },
  methods: {
    unselect() {
      this.$emit("input", null);
    },
    click(btnID) {
      if (this.validator) {
        this.validator.$touch();
      }
      if (this.formState) this.formState.dirty = true;

      this.$emit("input", btnID);
    },
    calc_variant(btn) {
      if (btn.id === this.value) {
        if (this.colorField) {
          return this.name + btn.id;
        }
        return "dark";
      }

      return "outline-secondary";
    },
  },
  computed: {
    buttons() {
      const vm = this;

      return _.sortBy(
        _.filter(this.items, function (o) {
          if (vm.quickDisplayOrderField) {
            return !!o[vm.quickDisplayOrderField];
          } else {
            return true;
          } // No quickDisplayOrderField so return all
        }),
        vm.quickDisplayOrderField
      );
    },
    all_other_buttons() {
      const vm = this;

      return _.sortBy(
        _.filter(filter_active_list(this.items), function (o) {
          if (vm.quickDisplayOrderField) {
            return !o[vm.quickDisplayOrderField];
          } else {
            return false; // no extras
          }
        }),
        this.textField
      );
    },
    other_buttons() {
      var items = this.all_other_buttons;
      const vm = this;

      // Filter by search
      items = _.filter(items, function (o) {
        return o[vm.textField].includes(vm.search);
      });

      return _.slice(items, 0, vm.maxMoreItems);
    },
  },
};
</script>

<style scoped></style>
